/* global axios */

import ApiClient from './ApiClient';

class EmailTemplatesAPI extends ApiClient {
  constructor() {
    super('email_templates', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  reset(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // REMOVER DEPOIS DE TESTAR — TmpEmailTemplateTest
  sendTest(id, { body } = {}) {
    return axios.post(`${this.url}/${id}/send_test`, { body });
  }
}

export default new EmailTemplatesAPI();
